import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import { Global } from '@emotion/core'
import Header from './Header'
import Footer from './Footer'

import 'bootstrap/dist/css/bootstrap.min.css'

import '../vendor/icon-awesome/css/font-awesome.min.css'
import '../vendor/icon-line/css/simple-line-icons.css'
import '../vendor/icon-etlinefont/style.css'
import '../vendor/icon-line-pro/style.css'
import '../vendor/icon-hs/style.css'
import '../vendor/animate.css'
import '../vendor/typedjs/typed.css'

import '../styles/unify.css'
import '../styles/unify-core.css'
import '../styles/unify-globals.css'
import '../styles/unify-components.css'

const Layout = props => {
  return (
    <>
      <Header />
        <main style={{paddingTop: '65px'}}>{props.children}</main>
      <Footer />
    </>
  )
}

export default Layout
